module.exports = __webpack_public_path__ + "img/collection-diamondJewelry100Carat.b6a8ba0.webp";